import { Injectable } from '@angular/core'
import { UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class PaymentMethodsGuard {
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (environment.features.paymentMethods) return true
    return false
  }
}
